import React from "react";
import { Grid } from "@material-ui/core";
import { Label } from "@progress/kendo-react-labels";
import { Input } from "@progress/kendo-react-inputs";
import "./inputs-form.css";

const InputsFormPure = (props) => {
  const { title } = props;

  return (
    <Grid item lg={12} md={12} sm={12} es={12}>
      <Label className="labels-title">{title}</Label>
      <Input
        className="style-input"
        {...props}
        component={props.validateInput}
      />
    </Grid>
  );
};

export { InputsFormPure as default };
